import barba from '@barba/core';
import { gsap, Linear } from "gsap";

import $ from 'jquery'
import 'slick-carousel'
import { nonDestroy } from './_abcdr-du-non-carrousel';

let homeFilter = "blur(2px)"

let animDuration = 0.45;

barba.init({
  schema: {
    prefix: 'data-anim'
  },
  transitions: [{
    name: 'home-to-single-transition',
    leave(data) {
        // return gsap.to(data.current.container, {
        //     filter: homeFilter,
        //     duration: animDuration
        // });

        // Détruire complètement le module carrousel ABCDR du Non avant la transition
        nonDestroy();

        var tl = gsap.timeline();
        // tl.timeScale(0.1);

        data.trigger.classList.add('anim-clicked');
        // data.trigger.style.width = data.trigger.getBoundingClientRect().width + "px";

        // Exclure les éléments du carrousel ABCDR du Non des animations
        const allButClicked = document.querySelectorAll(".section a:not(.anim-clicked):not(.carousel-non-link)");
        const itemInfos = data.trigger.querySelectorAll(".item-info");

        // Filtrer itemInfos pour exclure le titre du carrousel
        const filteredItemInfos = Array.from(itemInfos).filter(el => !el.classList.contains('carousel-non-title'));

        if (data.trigger.classList.contains('live')) {
          $('.lives-grid').slick('unslick');
          $('.live:not(.anim-clicked)').css('display', "none");
        }

        tl.to([allButClicked, ...filteredItemInfos], {
          opacity: 0,
          duration: animDuration,
          onComplete: () => {
            if (data.trigger.classList.contains('live')) {
              var livesEl = document.querySelectorAll('.section-lives .lives-ctn .lives-grid .slick-slide > div');
              var index = 0, length = livesEl.length;
              for ( ; index < length; index++) {
                  livesEl[index].style.transition ="none";
                  livesEl[index].style.transform ="none";
              }
            }
          }
        });

        // tl.set(itemInfos, {
        //   display: 'none'
        // })

        // console.log(data.trigger);


        return tl;
    },
    enter(data) {
      const isScreenSmall = document.body.clientWidth < 1024;

      var postNav = document.getElementById('post-nav');
      var postClose = document.getElementById('single-post-close-button');
      postNav.style.opacity = 0;
      postClose.style.opacity = 0;

      var tl = gsap.timeline();
      // tl.timeScale(0.1);

      // // Si c'est un élément du carrousel, réinitialiser son transform GSAP
      // if (data.trigger.classList.contains('carousel-non-link')) {
      //   const carouselItem = data.trigger.closest('.carousel-non-item');
      //   if (carouselItem) {
      //     gsap.set(carouselItem, { x: 0, y: 0, rotation: 0, scale: 1 });
      //   }
      // }

      const clickedImg = data.trigger.querySelector('.img-transition');

      const targetImg = data.next.container.querySelector('.visu-ctn');

      // itemSpace.style.width = data.trigger.getBoundingClientRect().width;
      // itemSpace.style.height = data.trigger.getBoundingClientRect().height;

      let itemSpace = data.trigger.cloneNode(true);
      itemSpace.style.opacity = 0;
      let parent = data.trigger.parentNode;
      let insert = false;

      if (data.trigger.classList.contains('album') || data.trigger.classList.contains('focus') || data.trigger.classList.contains('live')) {
        insert = true;
      }
      if (data.trigger.classList.contains('live') || data.trigger.classList.contains('focus') || data.trigger.classList.contains('carousel-non-item')) {
        clickedImg.style.height = clickedImg.getBoundingClientRect().height;
        clickedImg.style.width = clickedImg.getBoundingClientRect().width;
      }


      tl.set(clickedImg, {
        height: clickedImg.getBoundingClientRect().height,
        width: clickedImg.getBoundingClientRect().width,
        left: clickedImg.getBoundingClientRect().left,
        top: clickedImg.getBoundingClientRect().top,
        position:'fixed',
        zIndex:400,
        // x: '0',
        // y: '0',
      });

      tl.set(data.trigger, {
        position:'fixed',
        left: 0,
        top: 0,
        // width:'50%',
        width:'100%',
        height:'100%',
        zIndex:400,
        border:'none',
        onComplete: () => {
          if (insert == true) {
            parent.insertBefore(itemSpace, data.trigger.nextSibling);
            clickedImg.style.maxWidth = 'unset';
            clickedImg.style.maxHeight = 'unset';
          }
        }
      });


      // tl.set(data.trigger, {
      //   position:'fixed',
      //   left: data.trigger.getBoundingClientRect().left,
      //   top: data.trigger.getBoundingClientRect().top,
      //   width:'50%',
      //   // width:'100%',
      //   height:'100%',
      //   zIndex:400,
      //   border:'none',
      //   onComplete: () => {
      //     if (insert == true) {
      //       parent.insertBefore(itemSpace, data.trigger.nextSibling);
      //       clickedImg.style.maxWidth = 'unset';
      //       clickedImg.style.maxHeight = 'unset';
      //     }
      //   }
      // });

      tl.to(data.trigger, {
        left: 0,
        top:0,
        duration: animDuration,
        // ease: "none",
        // delay: -animDuration
      });

      
      let filter = document.createElement('div');
      filter.style.position = 'fixed';
      filter.style.top = 0;
      filter.style.left = 0;
      filter.style.backgroundColor = 'transparent';
      filter.style.border = 'none';
      filter.style.width = '100%';
      filter.style.height = '100%';

      data.trigger.appendChild(filter);

      tl.to(filter, {
        backdropFilter: homeFilter,
        duration: animDuration,
        delay: -animDuration,
      });
      
      if (data.trigger.classList.contains('focus')) {
        tl.to(clickedImg, {
          left: targetImg.getBoundingClientRect().left,
          top: targetImg.getBoundingClientRect().top,
          height: targetImg.getBoundingClientRect().height,
          width: targetImg.getBoundingClientRect().width,
          // x: '-50%',
          // y: '-50%',
          duration: animDuration,
          delay: -animDuration,
          // ease: "none",
        });
      } else if (data.trigger.classList.contains('carousel-non-item') || data.trigger.classList.contains('live')){
        tl.to(clickedImg, {
          left: targetImg.getBoundingClientRect().left,
          top: targetImg.getBoundingClientRect().top,
          height: targetImg.getBoundingClientRect().height,
          width: targetImg.getBoundingClientRect().width,
          // x: '-50%',
          // y: '-50%',
          duration: animDuration,
          delay: -animDuration,
          // ease: "none",
        });
      } else {
        tl.to(clickedImg, {
          left: targetImg.getBoundingClientRect().left,
          top: targetImg.getBoundingClientRect().top,
          height: targetImg.getBoundingClientRect().height - 6,
          width: targetImg.getBoundingClientRect().width - 6,
          // x: '-50%',
          // y: '-50%',
          duration: animDuration,
          delay: -animDuration,
          // ease: "none",
        });
      }

      var postInfos = document.getElementById('single-post-info');

      tl.from(data.next.container, {
          opacity: 0,
          duration: animDuration,
          // delay: -animDuration,
          // delay:1
      });

      
      tl.from(postInfos, {
          y: '100%',
          duration: animDuration,
          // delay:-animDuration,
          onComplete: () => {
          }
      });
      

      tl.to([postNav, postClose], {
          opacity: 1,
          duration: animDuration,
          // delay:-animDuration
      })

      return tl;
      // return gsap.from(data.next.container, {
      //   opacity: 0,
      //   delay:1
      // });
    },
    from: {

      // define rule based on multiple namespaces
      namespace: [
        'home'
      ]
    },
    to: {
      namespace: [
        'single'
      ]
    }
  },{
    name: 'single-to-single-transition',
    sync:true,
    leave(data) {
      return gsap.to(data.current.container, {
        opacity: 0,
        duration: animDuration,
      });
    },
    enter(data) {
      // return gsap.from(data.next.container, {
      //     filter: homeFilter,
      //     duration: animDuration,
      //     // delay:animDuration*2
      // });
      return gsap.from(data.next.container, {
          opacity: 0,
          duration: animDuration,
      });
    },
    from: {

      // define rule based on multiple namespaces
      namespace: [
        'single'
      ]
    },
    to: {
      namespace: [
        'single'
      ]
    }
  },{
    name: 'single-to-home-transition',
    sync:true,
    leave(data) {
      return gsap.to(data.current.container, {
        opacity: 0,
        duration: animDuration,
      });
    },
    enter(data) {
      // return gsap.from(data.next.container, {
      //     filter: homeFilter,
      //     duration: animDuration,
      //     // delay:animDuration*2
      // });
      return gsap.from(data.next.container, {
          opacity: 0,
          duration: animDuration,
      });
    },
    from: {

      // define rule based on multiple namespaces
      namespace: [
        'single'
      ]
    },
    to: {
      namespace: [
        'home'
      ]
    }
  }],
  views: [{
    namespace: 'home',
    beforeEnter(data) {
      // do something before entering the `home` namespace
    },
    beforeLeave(data) {
      // do something before leaving the current `home` namespace
    }
  }, {
    namespace: 'single',
    beforeEnter(data) {      
      // do something before entering the `single` namespace
    },
    beforeLeave(data) {
    },
    afterEnter(data) {
      // document.querySelector('.pochette-visu').classList.add('anim-init');
    }
  }]
});